module.exports = __webpack_public_path__ + "img/4eventfacilities.21e646f4.svg";